import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const assistLocaleModule: LocaleModule = {
  name: "assist",
  messages: { en: en, it: it },
};
